import { setLeadsListRctState } from "../leads_list_rct";

export function SubscriptionFreeResponse() {
	const Bark = window.Bark = window.Bark || {};
	const seller = Bark.seller = Bark.seller || {};
	const SubscriptionFreeResponse = seller.SubscriptionFreeResponse = seller.SubscriptionFreeResponse || {};

	const setFreeWithSubscriptionStatuses = (enabled, remaining) => {
		Bark.seller.debug({ message: 'setFreeWithSubscriptionStatuses', enabled, remaining });

		Bark.seller.GHGCreditStatus.updateFreeWithSubscriptionStatus(
			enabled,
			remaining,
		);

		for (const project of Bark.ProjectsData.projects) {
			project.n_free_leads_remaining = remaining;
		}

		if (!enabled) {
			for (const project of Bark.ProjectsData.projects) {
				if (project.is_free_with_subscription) {
					project.is_free = false;
				}

				project.is_free_with_subscription = false;
			}

			const project = Bark.seller.getProjectDataById(Bark.seller.currentlyShownProjectId);
			Bark.seller.GHGCreditStatus.setCreditPrice(project.is_free ? 0 : project.credits_required);

			Bark.seller.updateProjectPricing();
			setLeadsListRctState();
		}
	}

	SubscriptionFreeResponse.handleFreeWithSubscription = async () => {
		try {
			const freebieStatus = await Bark.api(
				`/user/${Bark.USER.userId}/subscriptions/feature/monthly-free-response/status`
			);

			Bark.seller.debug({ message: 'handleFreeWithSubscription', freebieStatus });

			setFreeWithSubscriptionStatuses(
				Boolean(freebieStatus?.enabled),
				freebieStatus?.data?.remaining || 0,
			);

			window.localStorage.setItem('free_with_subscription.status', JSON.stringify({
				enabled: Boolean(freebieStatus?.enabled),
				remaining: Number(freebieStatus?.data?.remaining || 0),
			}));
		} catch (e) {
		}
	};

	window.addEventListener('storage', function (e) {
		Bark.seller.debug({ message: 'storageEvent', e });

		if (e.key === 'free_with_subscription.status' && e.newValue) {
			// Listen to event updates from other tabs
			const status = JSON.parse(e.newValue);

			Bark.seller.debug({ message: 'storageEvent:free_with_subscription.status', status });

			setFreeWithSubscriptionStatuses(
				status.enabled,
				status.remaining,
			)
		}
	});
}
